import { render } from "./EditDiagnosisDialog.vue?vue&type=template&id=0a3ccfaa"
import script from "./EditDiagnosisDialog.vue?vue&type=script&lang=js"
export * from "./EditDiagnosisDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__